import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_skytrader.png",
      alt: "Estratégias SkyTrader",
    },
    title: "Liberte-se dos gráficos e invista sem esforço",

    // String ou array de strings
    text: [
      "AlgoTrader desde 2018, com mais de 250 clientes ao longo dessa jornada de desenvolvimento de diversas estratégias e ferramentas, com vasto know-how no mercado Forex e B3, fomos convidados a disponibilizar algumas de nossas melhores estratégias automatizadas para que você possa investir de maneira sólida e automatizada, mesmo sem possuir conhecimento nem precisar se dedicar a acompanhar o dia a dia do mercado.",
    ],
    testimonial: {
      text: "Pare de tentar ser o melhor jogador em campo e se torne um técnico inteligente. Você não precisa ser um escravo das telas para ter sucesso em seus investimentos",
      author: {
        name: "Walter Wolseley (@WALTER_ROBOS), Fundador da SkyTrader Tecnologia e Softwares",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "SkyTrader Tecnologia e Softwares",
    heading: "Principais estratégias para seu portfólio",
    subtitle:
      "As estratégias disponibilizadas fazem parte de um dos portfólios que eu e meus mentorados utilizamos",
  },

  cta: {
    title: "Liberte-se dos gráficos",
    subtitle: "Ative a extensão e seja bem-vindo ao meu mundo!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A SkyTrader",
    col1: [
      "Programador desde 2007, tive meu primeiro contato com o AlgoTrading em meados de 2018, quando mergulhei nesse universo incrível e decidi fundar a SkyTrader.",
      "Com mais de 250 clientes ao longo dessa jornada de desenvolvimento de diversas estratégias e ferramentas, com vasto know-how no mercado Forex e B3, em 2023 decidi “parar de vender robôs” e comecei a oferecer minha mentoria, para que os clientes possam ter acesso a um portfólio completo e obter os melhores resultados.",
      "Em 2024, fomos convidados a disponibilizar algumas de nossas melhores estratégias automatizadas nesta plataforma para que você possa investir de maneira sólida e automatizada, mesmo sem possuir conhecimento prévio nem precisar se dedicar a acompanhar o dia a dia do mercado.",
    ],
    col2: [
      // "Nosso compromisso com a qualidade é inegociável. Cada robô trader desenvolvido pela SigmaSix passa por rigorosos testes e análises para garantir seu desempenho e eficácia. Nosso objetivo é oferecer soluções que não apenas atendam, mas excedam as expectativas de nossos clientes.",
      // "Além disso, reconhecemos que cada investidor é único, com suas próprias necessidades e objetivos. Por isso, oferecemos soluções personalizadas e adaptadas às preferências e metas individuais de cada cliente. Nosso foco é sempre fornecer resultados tangíveis que ajudem nossos clientes a alcançar seus objetivos financeiros. ",
      // "A SigmaSix é mais do que uma empresa de tecnologia financeira. Somos uma comunidade de investidores, inovadores e visionários, unidos por uma paixão compartilhada pelo sucesso financeiro. Estamos comprometidos em construir um futuro onde todos tenham acesso a ferramentas e recursos que os capacitem a alcançar a liberdade financeira. Junte-se a nós e descubra o que a SigmaSix pode fazer por você.",
    ],
  },

  stats: {
    title: "Um pouco sobre nossos números",
    subtitle:
      "Desde 2018 desenvolvendo estratégias e ferramentas de AlgoTrading",
    data: [
      {
        value: "+250",
        description: "Clientes",
      },
      {
        value: "+6",
        description: "Anos de AlgoTrading",
      },
      {
        value: "+200",
        description: "Estratégias e ferramentas desenvolvidas",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da SkyTrader?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs",
    data: [
      {
        icon: iconsSet.code,
        title: "100% AlgoTrading",
        description:
          "Todas as operações são realizadas por algoritimos, sem intervenções manuais.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem Emoção",
        description:
          "Pare de sofrer ao ficar acompanhando estratégias subjetivas sem saber os possíveis resultados de cada operação.",
      },
      {
        icon: iconsSet.paper_board,
        title: "100% Objetivo",
        description:
          "Estratégias simples fundamentadas em validações estatísticas e que funcionam sem loucuras e com poucas operações diárias.",
      },
      {
        icon: iconsSet.lightbulb,
        title: "Seja Inteligente",
        description:
          "Pare de tentar ser o melhor jogador em campo e se torne um técnico inteligente.",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "+6 anos de experiência",
        description:
          "Siga as operações que possui vários anos de experiência nesse mercado.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte Personalizado",
        description:
          "Estamos sempre prontos para te atender e ajudar com o que precisar.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Estou bastante satisfeito, o Walter e sua equipe são fantásticos, confio 100%, equipe extremamente bacana e muito atenciosa, em especial o Walter, que nunca deixou de me atender prontamente.",
      author: "Ricardo Ignacio da Silva",
      job: "Perito Criminal",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Adquiri praticamente todos os produtos do Walter e hoje estou na mentoria. Comecei a utilizar desde junho de 2019 e a satisfação de ter começado se mantém desde o primeiro dia. Mesmo nos momentos mais conturbados da economia o atendimento e assessoramento se manteve centrado e fazendo a diferença na tomada de decisões, no meu caso algo que faz a diferença devido aos erros que cometia no calor do momento, por isso tenho total confiança em indicar a Skytrader.",
      author: "José Valtair Machado",
      job: "Militar da Força Aérea",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
